import React, { useState, useRef, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
//
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import Cookies from 'js-cookie'

const SurveyComponent = ({ surveyModel }) => {
  const [showSurvey, setShowSurvey] = useState(false)

  useEffect(() => {
    setShowSurvey(false)

    const timer = setTimeout(() => {
      setShowSurvey(true)
    }, 300)

    return () => clearTimeout(timer)
  }, [surveyModel])

  return showSurvey ? <Survey model={surveyModel} /> : <></>
}

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '驗證碼',
    placeholder: '請輸入驗證碼',
    alert: '請填寫您的手機或信箱',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)

  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(3)
  // }, [])
  const completedHtml = `<h4>問卷正在提交中，請稍候。</h4><h4>Your questionnaire is being submitted. Please wait.</h4><h4>請在成功頁面顯示後再離開。</h4><h4>Please do not leave until the success page is displayed.</h4>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q3: '{q2} = 0', // 請問您是否願意留下相關資訊，以便後續進行進一步聯繫？
    q4: '({q2} = 0 and {q3} = 0)',
    q5: '({q2} = 0 and {q3} = 0)',
    q6: '({q2} = 0 and {q3} = 0)',
    q7: '({q2} = 0 and {q3} = 0)',
    q8: '{q2} = 1',
    q9: '({q2} = 0 and {q3} = 0)',
    q10: '({q2} = 0 and {q3} = 0)',
    q11: '({q2} = 0 and {q3} = 0)',
    q12: '({q2} = 0 and {q3} = 0)',
    q13: '({q2} = 0 and {q3} = 0)',
    q15: '{q14} anyof [0]',
    q16: '{q14} anyof [1]',
    q17: '{q14} anyof [2]',
    q18: '{q14} anyof [3]',
    q19: '{q14} anyof [4]',
    q20: '{q14} anyof [5]',
    q21: '{q14} anyof [6]',
    q22: '{q14} anyof [7]',
    q23: '{q14} anyof [8]',
    q24: '{q14} anyof [0] and {q15} anyof [0]',
    q25: '{q14} anyof [0] and {q15} anyof [0]',
    q26: '{q14} anyof [0] and {q15} anyof [0]',
    q27: '{q14} anyof [0] and {q15} anyof [1]',
    q28: '{q14} anyof [0] and {q15} anyof [2]',
    // 友通
    q60: '{q14} anyof [0] and {q15} anyof [3]',
    q61: '{q14} anyof [0] and {q15} anyof [3]',
    q62: '{q14} anyof [0] and {q15} anyof [3]',
    q29: '{q14} anyof [0] and {q15} anyof [2]',
    q30: '{q14} anyof [1] and {q16} anyof [0]',
    q31: '{q14} anyof [1] and {q16} anyof [0]',
    q32: '{q14} anyof [1] and {q16} anyof [0]',
    q33: '{q14} anyof [1] and {q16} anyof [1]',
    q34: '{q14} anyof [1] and {q16} anyof [1]',
    q35: '{q14} anyof [1] and {q16} anyof [1]',
    q36: '{q14} anyof [2] and {q17} anyof [0]',
    q37: '{q14} anyof [2] and {q17} anyof [0]',
    q38: '{q14} anyof [2] and {q17} anyof [1]',
    q39: '{q14} anyof [2] and {q17} anyof [1]',
    q40: '{q14} anyof [2] and {q17} anyof [2]',
    q41: '{q14} anyof [3] and {q18} anyof [0]',
    q42: '{q14} anyof [3] and {q18} anyof [1]',
    q43: '{q14} anyof [3] and {q18} anyof [1]',
    q44: '{q14} anyof [3] and {q18} anyof [1]',
    // 逐鹿
    q45: '{q14} anyof [3] and {q18} anyof [3]',
    q46: '{q14} anyof [3] and {q18} anyof [3]',
    q47: '{q14} anyof [3] and {q18} anyof [3]',
    // 邁達特
    q48: '{q14} anyof [3] and {q18} anyof [2]',
    q49: '{q14} anyof [3] and {q18} anyof [2]',
    q50: '{q14} anyof [3] and {q18} anyof [2]',
    q51: '{q14} anyof [3] and {q18} anyof [4]',
    q52: '{q14} anyof [3] and {q18} anyof [4]',
    q53: '{q14} anyof [3] and {q18} anyof [4]',
    q54: '{q14} anyof [4] and {q19} anyof [0]',
    q55: '{q14} anyof [4] and {q19} anyof [0]',
    q56: '{q14} anyof [4] and {q19} anyof [1]',
    q57: '{q14} anyof [4] and {q19} anyof [1]',
    q58: '{q14} anyof [4] and {q19} anyof [2]',
    q59: '{q14} anyof [4] and {q19} anyof [3]',
    // q60: '{q14} anyof [5] and {q20} anyof [0]',
    // q61: '{q14} anyof [5] and {q20} anyof [0]',
    // q62: '{q14} anyof [5] and {q20} anyof [0]',
    q63: '{q14} anyof [5] and {q20} anyof [0]',
    q64: '{q14} anyof [5] and {q20} anyof [1]',
    q65: '{q14} anyof [6] and {q21} anyof [0]',
    q66: '{q14} anyof [7] and {q22} anyof [0]',
    q67: '{q14} anyof [7] and {q22} anyof [0]',
    q68: '{q14} anyof [7] and {q22} anyof [1]',
    q69: '{q14} anyof [7] and {q22} anyof [1]',
    q70: '{q14} anyof [7] and {q22} anyof [1]',
    q71: '{q14} anyof [7] and {q22} anyof [2]',
    q72: '{q14} anyof [7] and {q22} anyof [2]',
    q73: '{q14} anyof [7] and {q22} anyof [2]',
    q74: '{q14} anyof [8] and {q23} anyof [0]',
    q75: '{q14} anyof [8] and {q23} anyof [0]',
    q76: '{q14} anyof [8] and {q23} anyof [0]',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  const notRequired = [1]
  // const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  // const triggersConditionsInit = [
  //   {
  //     type: 'complete',
  //     expression:
  //       '({q1} = 0) or ({q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3)',
  //     //     expression: `{q3} <> 4 or ({q4} = 16 or {q4} = 20 or {q4} = 21)`,
  //   },
  //   {
  //     type: 'complete',
  //     expression: '{q6} notcontains 0',
  //   },
  // ]
  const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  const [convertedSurvey, setConvertedSurvey] = useState(null)
  const newConvertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
  })
  useEffect(() => {
    setConvertedSurvey(newConvertedSurvey)
  }, [newConvertedSurvey])

  // 當 ac 和 tk 值從 useConvertSurvey hook 獲取後，將其存儲到 cookie 中
  useEffect(() => {
    if (ac && tk) {
      // 將 ac 和 tk 存儲到 cookie，設定一天後過期
      Cookies.set('computex2025_ac', ac, {
        expires: 1,
        secure: true,
        sameSite: 'strict',
      })
      Cookies.set('computex2025_tk', tk, {
        expires: 1,
        secure: true,
        sameSite: 'strict',
      })
      console.log('已將 ac 和 tk 存入 cookie，一天後過期')
    }
  }, [ac, tk])

  const newSurvey = new Model(convertedSurvey)
  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])
  // const endMessage = `你填過囉`

  function helpFunction(survey, options) {
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // const endSurveyMsg = (survey) => {
  //   if (Cookies.get('hasVisited')) {
  //     setCompletionMessage(endMessage)
  //   } else {
  //     Cookies.set('hasVisited', true, { expires: 4, secure: true })
  //     setCompletionMessage('你沒填過')
  //   }
  //   // if (
  //   //   survey.getValue('q1') === 0 ||
  //   //   survey.getValue('q5') === 0 ||
  //   //   survey.getValue('q5') === 1 ||
  //   //   survey.getValue('q5') === 2 ||
  //   //   survey.getValue('q5') === 3
  //   // ) {
  //   //   setCompletionMessage(endMessage)
  //   // } else if (survey.getValue('q6') && !survey.getValue('q6').includes(0)) {
  //   //   setCompletionMessage(endMessage)
  //   // } else {
  //   //   setCompletionMessage(`<h2 style='text-align: center'>問卷已成功送出</h2>`)
  //   // }
  // }

  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})

  useSubmitAnswers({
    survey: newSurvey,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    // endSurveyMsg,
  })
  setIsLoading(false)

  return (
    <>
      {convertedSurvey ? (
        <SurveyComponent surveyModel={newSurvey} setIsLoading={setIsLoading} />
      ) : myAgreeJson ? (
        <SurveyComponent
          surveyModel={agreeSurvey}
          setIsLoading={setIsLoading}
        />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
